import CouponInput from "./CouponInput";

export default CouponInput;